import path from 'lodash/fp/path';
import pipe from 'lodash/fp/pipe';
import { STAGE_BRANCHES } from './constants';
import { dropLast, formatStagePath, filter, last, incrementTargetIndex, zip } from './utils';
import { hasValidIndex } from './predicates';

/**
 * @func getType
 * @param {Array<Object>} data
 * @return {String}
 *
 * (data: Object[]) => String
  * */
export const getType = path([0, 'type']);

/**
 * @func getType
 * @param {Array<Object>} data
 * @return {String}
 *
 * (data: Object[]) => String
  * */
export const getId = path([0, 'id']);

/**
 * @func getTargetIndex
 * @param {Number[]} stagePath - current selected path
 * @return {Number} target index
 *
 * (stagePath: Number[]) => Number
  * */
export const getTargetIndex = pipe(
  incrementTargetIndex,
  last,
);

/**
 * @func getInteractivePath
 * @param {Array<Number>} stagePath
 * @return {Array<String|Number>}
 *
 * (stagePath: Number[]) => Array<String|Number>
  * */
export const getInteractivePath = pipe(
  zip(STAGE_BRANCHES),
  filter(hasValidIndex),
);

/**
 * @func getTargetPath
 * @param {Number[]} stagePath
 * @return {Array<String|Number>} Immutable key path pointing to element in stage model
 *
 * (stagePath: Number[]) => Array<String|Number>
  * */
export const getTargetPath = pipe(
  incrementTargetIndex,
  getInteractivePath,
  formatStagePath,
  dropLast,
);
